module.exports = __webpack_public_path__ + "img/sdg10_id.bc078458.svg";